import { QueryKeys } from "@/api/core";
import { type Placeholder } from "@/schemas";

import { updatePageItem } from "./queries";

// Update the global placeholder query cache
const updatePlaceholderGlobalItem = (newPlaceholder: Placeholder) => {
  updatePageItem(
    QueryKeys.placeholders.global,
    newPlaceholder,
    (o: any, n: any) => String(o.id) === String(n.id),
  );
};

export { updatePlaceholderGlobalItem };
